import React, { useState, useEffect, useContext } from 'react';
import { NotificationContext } from '../../context/NotificationContext';
import api from '../../api';

const ApiKeyManager = ({ configId }) => {
  const { showNotification } = useContext(NotificationContext);
  const [apiKeys, setApiKeys] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    api_key: ''
  });

  useEffect(() => {
    loadApiKeys();
  }, [configId]);

  const loadApiKeys = async () => {
    try {
      const response = await api.get(`/admin/client_api_keys/${configId}`);
      setApiKeys(response.data);
    } catch (error) {
      showNotification('Error loading API keys: ' + error.message, true);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const submissionData = {
        configuration_id: parseInt(configId),
        name: formData.name,
        api_key: formData.api_key
      };

      await api.post('/admin/client_api_keys/', submissionData);
      showNotification('API key added successfully!');
      setIsModalOpen(false);
      setFormData({
        name: '',
        api_key: ''
      });
      loadApiKeys();
    } catch (error) {
      showNotification('Failed to add API key: ' + error.message, true);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this API key?')) return;

    try {
      await api.delete(`/admin/client_api_keys/${id}`);
      showNotification('API key deleted successfully!');
      loadApiKeys();
    } catch (error) {
      showNotification('Failed to delete API key: ' + error.message, true);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  return (
    <div className="section-card">
      <div className="section-header">
        <h2>API Keys</h2>
        <button 
          className="add-entity-btn"
          onClick={() => setIsModalOpen(true)}
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clipRule="evenodd"/>
          </svg>
          <span>Add API Key</span>
        </button>
      </div>
      
      <div className="section-content">
        <div className="table-wrapper">
          <table className="data-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>API Key</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {apiKeys.length === 0 ? (
                <tr>
                  <td colSpan="4" className="text-center py-4 text-gray-500">
                    No API keys found.
                  </td>
                </tr>
              ) : (
                apiKeys.map(apiKey => (
                  <tr key={apiKey.id}>
                    <td>{apiKey.name}</td>
                    <td>{apiKey.api_key}</td>
                    <td>
                      <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                        apiKey.active ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
                      }`}>
                        {apiKey.active ? 'Active' : 'Inactive'}
                      </span>
                    </td>
                    <td>
                      <button 
                        onClick={() => handleDelete(apiKey.id)}
                        className="text-red-600 hover:text-red-800 font-medium"
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {isModalOpen && (
        <div className="section-modal">
          <button 
            className="modal-close"
            onClick={() => setIsModalOpen(false)}
          >
            ×
          </button>
          <h3>Add API Key</h3>
          <form onSubmit={handleSubmit}>
            <div>
              <label className="form-label">Name</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                className="form-input"
                required
              />
            </div>
            <div>
              <label className="form-label">API Key</label>
              <input
                type="text"
                name="api_key"
                value={formData.api_key}
                onChange={handleInputChange}
                className="form-input"
                required
              />
            </div>
            <div className="modal-actions">
              <button type="button" onClick={() => setIsModalOpen(false)}>
                Cancel
              </button>
              <button type="submit" disabled={loading}>
                {loading ? 'Adding...' : 'Add API Key'}
              </button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
};

export default ApiKeyManager; 